export enum NotiThumbnailType {
  Default = 'DEFAULT',
  Cash = 'CASH',
  Heart = 'HEART',
  Gift = 'GIFT',
  Comment = 'COMMNET',
  ProductThumbnail = 'PRODUCT_THUMBNAIL',
  ThumbnailOrDefault = 'THUMBNAIL_OR_DEFAULT',
}
